// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventPlayerBoxScoreGetBody = {
  eventId: string;
};

export type typeEventPlayerBoxScoreGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    sportKey: "football" | "basketball" | "baseball" | "hockey";
    away: {
      teamId: string;
      tables: {
        key: string;
        label: string;
        columns: { key: string; label: string }[];
        rows: {
          playerId: string;
          name: string;
          position: string | null;
          headshotUrl: string | null;
          cells: { key: string; display: string }[];
        }[];
        totals: { key: string; display: string }[];
      }[];
    };
    home: {
      teamId: string;
      tables: {
        key: string;
        label: string;
        columns: { key: string; label: string }[];
        rows: {
          playerId: string;
          name: string;
          position: string | null;
          headshotUrl: string | null;
          cells: { key: string; display: string }[];
        }[];
        totals: { key: string; display: string }[];
      }[];
    };
  };
};

export type typeEventPlayerBoxScoreGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlayerBoxScoreGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlayerBoxScoreGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventPlayerBoxScoreGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventPlayerBoxScoreGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventPlayerBoxScoreGetBody);
  }

  return async function postEventPlayerBoxScoreGet(
    payload: typeEventPlayerBoxScoreGetBody,
  ): Promise<
    typeEventPlayerBoxScoreGetOutput200 | typeEventPlayerBoxScoreGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventPlayerBoxScoreGet" failed before calling the network. #cc5666406092`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#cc5666406092" },
        },
        data: null,
      } as typeEventPlayerBoxScoreGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/player-box-score-get`,
      httpMethod: "POST",
      options,
    })) as
      typeEventPlayerBoxScoreGetOutput200 | typeEventPlayerBoxScoreGetOutput400;
  };
}
